<div style="text-align:center">
    <div>
        <webcam [height]="200" [width]="200" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
            *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
            [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
            (initError)="handleInitError($event)"></webcam>
        <br>
        <button class="actionBtn" (click)="triggerSnapshot();" title="Take Picture">📸</button>
        <!-- <div class="actio   nBtn" (click)="showNextWebcam(true);" title="Switch Camera">🔁</div> -->
        <br>
        <span style="text-align:center" *ngFor="let error of errors">
            {{error.message | json}}
        </span>
    </div>
</div>